import{useState as r,useEffect as t}from"react";var o=function(o){var a=r(void 0),n=a[0],e=a[1];return t(function(){e(o)},[o]),n};export{o as default};
//# sourceMappingURL=index.js.map
